import React from 'react';
import {
  Form,
  Input,
  RequiredHelpPhrase,
  Row,
  SonForm,
  SubmitButton,
  TextParam,
  UrlParam,
  useForm,
} from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type RssFeedCreateOrEditForm = SonForm<TextParam<'title'> | UrlParam<'url'>>;

export function RssFeedCreateOrEditForm({ form, onSuccess }: { form: RssFeedCreateOrEditForm; onSuccess: () => void }) {
  const { t } = useSonTranslation('RssFeed');
  const { formProps, fetchState, params } = useForm({ form, onSuccess });

  const urlParam = params.getByName('url');
  const titleParam = params.getByName('title');

  return (
    <Form {...formProps} id="rss-feed-form">
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('editView.createOrEdit.title')} param={titleParam} />
      </Row>
      <Row>
        <Input label={t('editView.createOrEdit.url')} param={urlParam} />
      </Row>
      <SubmitButton
        buttonLabel={t('editView.createOrEdit.submitButton')}
        messageSuccess={t('editView.createOrEdit.status.success')}
        messageSending={t('editView.createOrEdit.status.sending')}
        messageFail={t('editView.createOrEdit.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
